import React from 'react';
import { toJS } from 'mobx';
import './index.scss';
import { observer, inject } from 'mobx-react';

import CustomButton from '../../../components/basic/CustomButton'
import SelectSearch from '../../../components/basic/SelectSearch/SelectSearch';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import CustomInput from '../../../components/basic/input'
import ListItem from '@material-ui/core/ListItem';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import CircularProgress from '@material-ui/core/CircularProgress';


import { api } from '../../../functions/api'

@inject('translate')
@inject('internal')
@observer
export default class EditOrAddCategory extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loadingBtn: false,
            checked: props.idCategory ? this.editCategory.production : false,
            has_static_sets: props.idCategory ? this.editCategory.has_static_sets : false,
            // parent_id: this.props.idParent,
            parent_id: -1,
            show: false,
            productionWasChanged: false,
            values: [],
            selectedObjects: [],
            selectedNames: [],
            loading: false,
            attachedParameters: [],
            allParameters: []
        }
    }

    componentWillReceiveProps() {
        // setTimeout(function(){

        // }, 10)
        // this.setState({parent_id: Number(this.props.internal.parent_id)})

    }

    componentDidMount() {
        this.loadCategories2()
        this.setState({ parent_id: this.props.idParent })
    }

    timeout = null;
    addParameter = (param) => {
        this.setState({ attachedParameters: param })

        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
            this.updateCategoryParameter()
        }, 2000)
    }

    updateCategoryParameter = async () => {
        let ids = this.state.attachedParameters.map(param => Number(param.id))
        // /lists/categories/:id/parameters
        let update_category_params = await api({
            method: 'patch',
            url: `lists/categories/${this.props.idCategory}/parameters`,
            authorization: this.props.internal.user.access_token,
            params: {
                ids: ids
            }
        })

        if (update_category_params.success === true) {
            this.props.internal.setSnackbar(update_category_params.data.message, true);
        }
        else {
            this.props.internal.setSnackbar(update_category_params.data.message, true);
        }
    }

    loadCategories2 = () => {
        const { dataForTable } = toJS(this.props.internal)
        let firstObj = dataForTable.data

        // firstObj.push({name: "TOP level", parent_id: null, id:0, children: [], level: 0})
        firstObj.splice(0, 0, {
            name: "TOP level",
            parent_id: null,
            id: 0,
            children: [],
            level: 0
        })


        this.setState({
            // values: [firstObj],
            values: [firstObj],
        })


        if (this.props.idCategory && this.props.idParent !== null) {
            this.makeRoute()
        }
        else {
            this.makeRoute2()
        }


        let allParameters = []
        for (let param in dataForTable.lists.parameters) {
            allParameters.push({
                id: dataForTable.lists.parameters[param].id,
                value: dataForTable.lists.parameters[param].id,
                label: dataForTable.lists.parameters[param].internal_name
            })
        }
        this.setState({
            allParameters: allParameters
        })
    }

    makeRoute2 = () => {
        let categories = toJS(this.props.internal.listCategories)
        for (let i = 0; i < categories.length; i++) {
            if (this.props.idCategory) {
                if (categories[i].id === this.props.idCategory) {
                    this.editCategory = categories[i]
                    let attachedParameters = []
                    for (let param in this.editCategory.parameters) {
                        attachedParameters.push({
                            id: this.editCategory.parameters[param].id,
                            value: this.editCategory.parameters[param].id,
                            label: this.editCategory.parameters[param].internal_name
                        })
                    }
                    this.setState({ attachedParameters: attachedParameters, loading: false, selectedObjects: [this.editCategory], checked: this.editCategory.production })
                }
            }
        }

        // let parentsOfCategory = []

        // let tmpValues = this.state.values
        // if (this.editCategory.parent_id !== null) {
        //     let parent = categories.filter(i => i.id === this.editCategory.parent_id)[0]
        //     parentsOfCategory.push(parent)

        //     while (parent.parent_id !== null) {
        //         parent = categories.filter(i => i.id === parent.parent_id)[0]
        //         parentsOfCategory.push(parent)

        //     }

        //     parentsOfCategory.reverse();

        //     // let tmpValues = this.state.values
        //     for (let i = 0; i < parentsOfCategory.length; i++) {
        //         if (parentsOfCategory[i].children) {
        //             tmpValues.push(parentsOfCategory[i].children)
        //         }
        //     }
        // }
        // this.setState({ selectedObjects: parentsOfCategory, values: tmpValues })
    }

    makeRoute = () => {

        let categories = toJS(this.props.internal.listCategories)
        for (let i = 0; i < categories.length; i++) {
            if (this.props.idCategory) {
                if (categories[i].id === this.props.idCategory) {
                    this.editCategory = categories[i]
                    let attachedParameters = []
                    for (let param in this.editCategory.parameters) {
                        attachedParameters.push({
                            id: this.editCategory.parameters[param].id,
                            value: this.editCategory.parameters[param].id,
                            label: this.editCategory.parameters[param].internal_name
                        })
                    }
                    this.setState({ attachedParameters: attachedParameters, loading: false })
                }
            }
        }

        let parentsOfCategory = []

        let tmpValues = this.state.values

        const { dataForTable } = toJS(this.props.internal)
        let firstObj = dataForTable.data

        // firstObj.push({name: "TOP level", parent_id: null, id:0, children: [], level: 0})
        firstObj.splice(0, 0, {
            name: "TOP level",
            parent_id: null,
            id: 0,
            children: [],
            level: 0
        })

        tmpValues.push(firstObj)

        if (this.editCategory.parent_id !== null) {
            let parent = categories.filter(i => i.id === this.editCategory.parent_id)[0]
            parentsOfCategory.push(parent)

            while (parent.parent_id !== null) {
                parent = categories.filter(i => i.id === parent.parent_id)[0]
                parentsOfCategory.push(parent)

            }

            parentsOfCategory.reverse();

            // let tmpValues = this.state.values
            for (let i = 0; i < parentsOfCategory.length; i++) {
                if (parentsOfCategory[i].children) {
                    tmpValues.push(parentsOfCategory[i].children)
                }
            }
        }

        // parentsOfCategory.push(this.editCategory)

        this.setState({ selectedObjects: parentsOfCategory, values: tmpValues })
        // this.setState({ selectedObjects: parentsOfCategory, })


    }

    updateOrAddCategory = async () => {
        this.setState({ loadingBtn: true })
        if (this.title.state.value !== "") {
            let title;
            let description;
            let parent_id;
            let checked;
            let has_static_sets;
            let editable_alias;
            let page_title;


            title = this.title.state.value;
            description = this.description.state.value;
            parent_id = this.state.parent_id
            editable_alias = this.editable_alias.state.value
            page_title = this.page_title.state.value;
            
            // parent_id = this.state.parent_id !== null ? this.state.parent_id : toJS(this.props.internal.dataForTable.data[0].id)

            // if (this.state.productionWasChanged) {
            //     checked = this.state.checked
            // }
            // else {
            //     if (this.editCategory.production) {
            //         checked = this.editCategory.production
            //     }

            // }

            checked = this.state.checked
            has_static_sets = this.state.has_static_sets

            if (Number(parent_id) === -1 || Number(parent_id) === 0) {
                parent_id = null
            }


            let url = 'lists/categories';

            let method = "post";
            if (this.props.idCategory) {
                url += "/" + this.props.idCategory
                method = "patch"
            }

            let params = {
                name: title,
                description: description,
                parent_id: parent_id,
                production: checked,
                has_static_sets: has_static_sets,
                page_title: page_title
            }


            if (editable_alias !== this.editCategory.alias) {
                params.alias = editable_alias
            }


            let create_data = await api({
                method: method,
                url: url,
                authorization: this.props.internal.user.access_token,
                params: params
            })

            if (create_data.success === true || (create_data.data.error === false && create_data.status === 201)) {
                this.props.showSnackbar(create_data.data.message, true)
                if (this.props.idCategory) {
                    let dataEdit = {
                        edit: false,
                        id: null
                    }
                    this.props.internal.setActionEdit(dataEdit)

                }
                this.props.onClose(true)
            }
            else {
                let resultError = "";
                for (let error in create_data.data.data.errors) {
                    resultError += create_data.data.data.errors[error] + " "
                }
                this.props.showSnackbar(resultError, true)
            }
        }
        else {
            this.props.internal.setSnackbar(this.props.translate.i18n.GLOBAL.ALERTS.NAME_REQUIRED, true)
        }

        this.setState({ loadingBtn: false })
    }

    handleChangeCheckbox = (event) => {
        this.setState({ checked: event.target.checked, productionWasChanged: true })
    }

    handleChangeHasStaticSets = (event) => {
        this.setState({ has_static_sets: event.target.checked })
    }

    handleChangeParent = (event) => {
        this.setState({ parent_id: event.target.value })
    }

    handleChange = (event) => {
        if (event.target.value !== "") {
            let values = this.state.values;
            values.splice(event.target.value.level + 1);
            let selectedObj = this.state.selectedObjects
            selectedObj.splice(event.target.value.level);
            selectedObj.push(event.target.value)
            this.setState({ selectedObjects: selectedObj, })

            let selectedNames = this.state.selectedNames
            selectedNames.push(event.target.value.name)
            if (event.target.value.hasOwnProperty("id")) {
                this.setState({ selectedNames: selectedNames, parent_id: event.target.value.id })
            }
            else {
                let parent = selectedObj[selectedObj.length - 2]
                this.setState({ selectedNames: selectedNames, parent_id: parent.id })
            }

            if (event.target.value.children.length) {
                values.push(event.target.value.children)
                this.setState({ values: values })
            }
        }

    }

    timeout2 = null
    handleSuggestAlias = () => {

        if (this.isEmpty(this.editCategory)) {
            clearTimeout(this.timeout2)
            this.timeout2 = setTimeout(() => {
                this.aliasSuggestion()
            }, 500)
        }
    }

    aliasSuggestion = async () => {
        let alias_suggestion = await api({
            method: 'POST',
            url: 'lists/categories/suggest-slug',
            authorization: this.props.internal.user.access_token,
            params: {
                name: this.title.state.value
            }
        })

        if (alias_suggestion.success === true) {
            this.editable_alias.setValue(alias_suggestion.data.data.alias)
        }
    }

    isEmpty(obj) {
        for (var key in obj) {
            if (obj.hasOwnProperty(key))
                return false;
        }
        return true;
    }

    editCategory = {};
    render() {


        return (
            <Dialog
                open={this.props.open}
                onClose={() => this.props.onClose(false)}
                aria-labelledby="form-dialog-title"
                classes={{
                    root: "edit-add-category-root",
                    paper: "edit-add-category-paper"
                }}
            // style={{overflowY: "initial"}} //pre dropdown
            >
                <DialogTitle id="form-dialog-title">{this.props.title}</DialogTitle>

                {/* style={{ overflow: "initial" }} */}
                <DialogContent classes={{ root: 'dialog-category' }} >
                    {this.state.loading ?
                        <CircularProgress className={'circular-progress'} />
                        :
                        <div>
                            <div className={'flex edit-category'} >
                                <CustomInput
                                    ref={ref => this.title = ref}
                                    text={this.props.translate.i18n.MODULES.CATEGORIES.NAME}
                                    value={this.props.idCategory ? this.editCategory.name : ""}
                                    id={'name'}
                                    className={"w-50"}
                                    required
                                    change={this.handleSuggestAlias}
                                />
                                <div className={'categories'}>
                                    {/* <FormControl className='tags-selector'>
                                        <InputLabel htmlFor={`category-0`} className={'label-select-tag'}>{this.props.translate.i18n.MODULES.PRODUCTS.CHOOSE_CATEGORY}</InputLabel>
                                        <Select
                                            className={'select-category'}
                                            value={this.state.selectedObjects[0] ? this.state.selectedObjects[0].name : ""}
                                            onChange={this.handleChange}
                                            // renderValue={selected => {return(<span>{this.state.selectedObjects[index] ? this.state.selectedObjects[index].name : ""}</span>)}}
                                            renderValue={() => {
                                                return (
                                                    <span>{this.state.selectedObjects[0].name}</span>
                                                )
                                            }}
                                        >

                                            <MenuItem key="0" value={{ name: this.props.translate.i18n.MODULES.PRODUCTS.CATEGORY_NONE, children: [], level: 0 }}>{this.props.translate.i18n.MODULES.PRODUCTS.CATEGORY_NONE}</MenuItem>

                                            {
                                                this.state.selectedObjects.map((option, optionIndex) => {
                                                    return (
                                                        <MenuItem key={optionIndex} value={option} disabled={option.id === this.editCategory.id}>{option.name}</MenuItem>
                                                    )
                                                })
                                            }
                                        </Select>
                                    </FormControl> */}
                                    {
                                        this.state.values.map((options, index) => {
                                            return (

                                                <React.Fragment key={index}>
                                                    <FormControl className='tags-selector'>
                                                        {index === 0 ? <InputLabel htmlFor={`category-${index}`} className={'label-select-tag'}>{this.props.translate.i18n.MODULES.PRODUCTS.CHOOSE_CATEGORY}</InputLabel> : null}
                                                        <Select
                                                            className={'select-category'}
                                                            value={this.state.selectedObjects[index] ? this.state.selectedObjects[index].name : ""}
                                                            onChange={this.handleChange}
                                                            // renderValue={selected => {return(<span>{this.state.selectedObjects[index] ? this.state.selectedObjects[index].name : ""}</span>)}}
                                                            renderValue={() => {
                                                                return (
                                                                    <span>{this.state.selectedObjects[index].name}</span>
                                                                )
                                                            }}
                                                        >
                                                            {
                                                                index > 0 ? <MenuItem key="0" value={{ name: this.props.translate.i18n.MODULES.PRODUCTS.CATEGORY_NONE, children: [], level: index }}>{this.props.translate.i18n.MODULES.PRODUCTS.CATEGORY_NONE}</MenuItem> : null
                                                            }
                                                            {
                                                                options.map((option, optionIndex) => {
                                                                    return (
                                                                        <MenuItem key={optionIndex} value={option} disabled={option.id === this.editCategory.id}>{option.name}</MenuItem>
                                                                    )
                                                                })
                                                            }
                                                        </Select>
                                                    </FormControl>
                                                </React.Fragment>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                            {/* <div className={'params-description'}> */}
                                <SelectSearch
                                    options={this.state.allParameters}
                                    onChange={val => this.addParameter(val)}
                                    value={this.state.attachedParameters}
                                    isMulti={true}
                                    className={'select-search'}
                                    label={this.props.translate.i18n.MODULES.CATEGORIES.PARAMETERS}
                                // menuIsOpen
                                />
                                <CustomInput
                                    ref={ref => this.description = ref}
                                    text={this.props.translate.i18n.MODULES.CATEGORIES.DESCRIPTION}
                                    value={this.props.idCategory ? this.editCategory.description : ""}
                                    id={'categoryDescription'}
                                    // className={"w-100"}
                                    italic
                                    multiline={true}
                                    className={'categoryDescription'}
                                />
                            {/* </div> */}
                            <div className={'editableAliasPageTitle'} >
                                <CustomInput
                                    ref={ref => this.editable_alias = ref}
                                    text={this.props.translate.i18n.MODULES.CATEGORIES.EDITABLE_ALIAS}
                                    value={this.props.idCategory ? this.editCategory.editable_alias : ""}
                                    id={'editable_alias'}
                                    // className={"w-50"}
                                    required
                                />
                                <CustomInput
                                    ref={ref => this.page_title = ref}
                                    text={this.props.translate.i18n.MODULES.CATEGORIES.PAGE_TITLE}
                                    value={this.props.idCategory ? this.editCategory.page_title : ""}
                                    id={'page_title'}
                                    // className={"w-50"}
                                />
                            </div>
                            <ListItem dense onChange={this.handleChangeCheckbox} className={'list-item'}>
                                <input
                                    id={"production"}
                                    type="checkbox"
                                    value={"production"}
                                    defaultChecked={this.props.idCategory ? this.editCategory.production : false}
                                />
                                <label htmlFor={"production"}>{this.props.translate.i18n.GLOBAL.TABLE.ACTIVE}</label>
                            </ListItem>
                            <ListItem dense onChange={this.handleChangeHasStaticSets} className={'list-item'}>
                                <input
                                    id={"has_static_sets"}
                                    type="checkbox"
                                    value={"has_static_sets"}
                                    defaultChecked={this.props.idCategory ? this.editCategory.has_static_sets : false}
                                />
                                <label htmlFor={"has_static_sets"}>{this.props.translate.i18n.GLOBAL.TABLE.HAS_STATIC_SETS}</label>
                            </ListItem>

                        </div>
                    }
                </DialogContent>

                <DialogActions>
                    <Button onClick={() => this.props.onClose(false)} className={'gray-text'}>
                        {this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}
                    </Button>
                    <CustomButton
                        progressBar={this.state.loadingBtn}
                        onClick={this.updateOrAddCategory}
                        mystyle={'btn-white-bg'}
                        title={this.props.translate.i18n.GLOBAL.BUTTONS.SAVE}
                        justText
                        disabled={this.state.loading}
                    />
                </DialogActions>

            </Dialog>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/categories/EditAdd/index.js